import { Box, Typography, useTheme } from "@mui/material";
import React from "react";
import { groupIngredientsByGroup } from "../../utils/ingerdientUtils";

const GroupedIngredientsSection = ({ ingredients }) => {
  const groupedIngredients = groupIngredientsByGroup(ingredients);
  const theme = useTheme();

  return (
    <Box component="section" aria-labelledby="ingredients-heading" px={2} py={2}>
      {Object.entries(groupedIngredients).map(([group, items], groupIndex) => (
        <Box key={group} component="div" role="group" aria-labelledby={`ingredient-group-${groupIndex}`} mb={4}>
          {group !== "__no_group__" && (
            <Typography
              id={`ingredient-group-${groupIndex}`}
              component="h3"
              variant="h6"
              sx={{
                fontWeight: 600,
                mb: 1.5,
                mt: groupIndex > 0 ? 2 : 0,
                borderBottom: `solid ${theme.palette.divider}`,
                color: theme.palette.text.primary,
              }}
            >
              {group}
            </Typography>
          )}

          <Box
            component="ul"
            sx={{
              listStyle: "none",
              pl: 0,
              m: 0,
              display: "flex",
              flexDirection: "column",
              gap: 1.5,
            }}
          >
            {items.map((ingredient, index) => (
              <Box
                key={index}
                component="li"
                display="flex"
                justifyContent="space-between"
                flexWrap="wrap"
                alignItems="flex-start"
                py={1}
                sx={{
                  borderBottom: `0.5px solid ${theme.palette.divider}`,
                }}
              >
                <Typography
                  component="span"
                  variant="body1"
                  sx={{
                    fontWeight: 500,
                    color: theme.palette.text.primary,
                    flex: "1 1 50%",
                    minWidth: 140,
                  }}
                >
                  {ingredient.name}
                </Typography>

                <Box display="flex" flexDirection="column" alignItems="flex-end" flex="1 1 40%">
                  <Typography component="span" variant="body1" sx={{ color: theme.palette.text.secondary, fontWeight: 500 }}>
                    {ingredient.quantity} {ingredient.unit}
                  </Typography>

                  {ingredient.notes && (
                    <Typography
                      component="span"
                      variant="body2"
                      sx={{
                        fontStyle: "italic",
                        color: theme.palette.text.secondary,
                        mt: 0.5,
                        fontSize: "0.85rem",
                        maxWidth: 240,
                        textAlign: "right",
                      }}
                    >
                      {ingredient.notes}
                    </Typography>
                  )}
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default GroupedIngredientsSection;
